import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    auth: {
      name: '',
      username: '',
      user_type_id: 0
    },
    permissions: []
  }
})



// WEBPACK FOOTER //
// ./src/store.js